import { defineComponent as _defineComponent } from 'vue'
import { PropType } from "vue"
import Icon from "@/components/widgets/icons/Icon.vue"
import { ClientDetailFragmentFragment } from "@/gql"
import { useUtilities } from "@/hooks/useUtilities"


export default /*#__PURE__*/_defineComponent({
  __name: 'Subscriptions',
  props: {
  subscriptions: {
    type: Array as PropType<ClientDetailFragmentFragment["subscriptions"] | null>,
  },
},
  setup(__props) {



const { formatDate } = useUtilities()

return { __sfc: true,formatDate, Icon }
}

})